<modal id="career-test">
	<div class="modal">
		<div class="modal__block-icon modal__block-icon--mobile">
			<img class="modal__cross modal__cross--desktop" (click)="closeModal('career-test');"
				 src="assets/images/education/icons/icon__cross--white.svg" alt="">
			<img class="modal__cross modal__cross--mobile" (click)="closeModal('career-test');"
				 src="assets/images/education/icons/icon__cross--red.svg" alt="">
		</div>
		<div class="modal__container" *ngIf="data && !resultTest">
			<div class="modal__page-number">{{ idActiveQuestion + 1 }} / {{ data.length }}</div>
			<div class="modal__inner">
				<h3 class="modal__title">{{ activeQuestion.question }}</h3>

				<form class="modal__form">
					<div class="modal__form-inner">
						<div class="modal__form-input" *ngFor="let data of activeQuestion.answers">
							<input id="answer{{data.id}}" type="radio"
								   name="radio"
								   value="{{data.id}}"
								   [(ngModel)]="selectedOption">
							<label for="answer{{data.id}}">{{ data.answer }}</label>
						</div>
					</div>
					<div class="modal__form-navigation">
						<button (click)="prevQuestion()"
								class="modal__button--bg"
								[class.disabled]="idActiveQuestion == 0"
								[disabled]="idActiveQuestion == 0">Назад
						</button>
						<button *ngIf=" idActiveQuestion + 1 != data.length"
								class="modal__button--white"
								[class.disabled]="idActiveQuestion == data.length || !selectedOption"
								[disabled]="idActiveQuestion == data.length || !selectedOption"
								(click)="nextQuestion()">Далее
						</button>
						<button *ngIf="selectedOption && (idActiveQuestion + 1) == data.length"
								class="modal__button--white"
								(click)="sendData()">
							Отправить
						</button>
					</div>
				</form>
			</div>
		</div>

		<div class="result-test" *ngIf="resultTest">
			<div class="result-test__inner">
				<div class="result-test__left">
					<h2 class="result-test__title">Твои сильные стороны</h2>
					<div class="result-test__skills">
						<div class="result-test__skill" *ngFor="let skill of resultTest.skills | slice:0:3; let i = index;">
							<div class="result-test__number">{{ i + 1 }}</div>
							<div class="result-test__item">{{ skill.skillName }}</div>
						</div>
					</div>
				</div>
				<div class="result-test__right">
					<h2 class="result-test__title">Мэтч со специальностями</h2>
					<div class="result-test__inner-circle" [class.active]="dataLoaded">

						<div class="result-test__element" *ngFor="let role of resultTest.roles;">
							<div class="progress-circle"
								 [attr.data-progress]="roundNumber(role.progress)">
								<div class="progress-circle__text">{{ role.roleName }}</div>
								<div class="circle">
									<div class="full progress-circle__slice">
										<div class="progress-circle__fill"></div>
									</div>
									<div class="progress-circle__slice">
										<div class="progress-circle__fill"></div>
										<div class="progress-circle__fill progress-circle__bar"></div>
									</div>
									<div class="progress-circle__overlay"></div>
								</div>
							</div>

							<div class="result-test__element-text">{{ role.roleName }}</div>
						</div>
					</div>

				</div>
			</div>
			<div class="result-test__footer" (click)="scrollToParentAnchor()">Попробуй себя на стажировке</div>
		</div>
	</div>
	<div class="modal__background" (click)="closeModal('career-test');"></div>
</modal>
